import { pathForNextNavigation } from '@/lib/appBasePath';

/** True when the pathname is on (or under) any route a section item fronts via `NavItem.routes`. */
export function isOnItemRoutes(routes: { path: string }[] | undefined, pathname: string | null): boolean {
  if (!routes?.length) return false;
  const normPathname = pathForNextNavigation(pathname || '');
  return routes.some((r) => {
    const normR = pathForNextNavigation(r.path);
    return normPathname === normR || normPathname.startsWith(normR + '/');
  });
}
